import React from 'react';
import WordContainer from './WordContainer';

const P = ({ active }) => {

    return (
        active === "p" &&
        <div>
            <WordContainer
                text="pāpā"
                file="papa.mp3"
                translation="R"
            />
            <WordContainer
                text="pepeha"
                file="pepeha.mp3"
                translation="R"
            />
            <WordContainer
                text="poipoia"
                file="poipoia.mp3"
                translation="R"

            />
            <WordContainer
                text="pōkarekare"
                file="pokarekare.mp3"
                translation="R"

            />
            {/* <WordContainer
                text="pōkarekare ana"
                file="pokarekare_ana.mp3"
                translation="R"

            /> */}
            <WordContainer
                text="puke"
                file="puke.mp3"
                translation="R"
                border
            />
        </div>
    )
}

export default P;